export const MY_PRICING_DEFAULT_PAGE_SIZE = 10;

export const MY_PRICING_SEGMENT = {
  Open: "Open",
  Closed: "Closed",
} as const;

export type MyPricingSegment =
  (typeof MY_PRICING_SEGMENT)[keyof typeof MY_PRICING_SEGMENT];

export const MY_PRICING_TABLE_META: Record<
  MyPricingSegment,
  { title: string; description: string; emptyText: string }
> = {
  Open: {
    title: "Active Briefs",
    description:
      "Briefs with pending pricing, open renegotiation asks, or brand counters awaiting POC action.",
    emptyText: "No active briefs",
  },
  Closed: {
    title: "Closed Briefs",
    description: "100% complete — all creators priced on these briefs.",
    emptyText: "No closed briefs",
  },
};

export const ACTIVE_STAT_CARDS = [
  {
    label: "No of campaigns",
    key: "activeBriefsCount",
  },
  {
    label: "Total creators allocated",
    key: "activeBriefInfluencersAllocatedCount",
  },
  {
    label: "Total creators priced",
    key: "activeBriefInfluencersPricedCount",
  },
] as const;

export const CLOSED_STAT_CARDS = [
  {
    label: "Total Campaigns Closed",
    key: "closedBriefsCount",
  },
  {
    label: "Total Creators Priced",
    key: "closedBriefInfluencersPricedCount",
  },
] as const;
